import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "mode", "closeButtonEnabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MobileDrawerCustom } from '@sbercloud/uikit-product-mobile-drawer';
import { MODE, SIZE } from '../../constants';
import { ModalBody, ModalFooter, ModalHeader } from '../../helperComponents';
import { jsx as _jsx } from "react/jsx-runtime";
export function MobileModalCustom(_ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE.Auto : _ref$size,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? MODE.Regular : _ref$mode,
    _ref$closeButtonEnabl = _ref.closeButtonEnabled,
    closeButtonEnabled = _ref$closeButtonEnabl === void 0 ? false : _ref$closeButtonEnabl,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(MobileDrawerCustom, _objectSpread(_objectSpread({}, rest), {}, {
    modalMode: mode,
    size: size === SIZE.Auto ? 'auto' : '100%',
    hasBorderRadius: true,
    position: "bottom",
    swipeEnabled: true,
    closeButtonEnabled: closeButtonEnabled
  }));
}
(function (_MobileModalCustom) {
  var Header = _MobileModalCustom.Header = ModalHeader;
  var Body = _MobileModalCustom.Body = ModalBody;
  var Footer = _MobileModalCustom.Footer = ModalFooter;
})(MobileModalCustom || (MobileModalCustom = {}));